function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var NFTSecurityOverlayTemplate = require('./nft-security-overlay.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var NFTSecurityOverlay = /*#__PURE__*/function () {
  function NFTSecurityOverlay(app, mod) {
    var _app$browser;
    _classCallCheck(this, NFTSecurityOverlay);
    this.app = app;
    this.mod = mod;
    if (app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.addStylesheet) {
      app.browser.addStylesheet('/saito/css-imports/ui/saito-nft.css');
    }
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.level = 'low';
    this.onConfirm = null;
  }
  return _createClass(NFTSecurityOverlay, [{
    key: "render",
    value: function render() {
      var _nft$tx;
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'low';
      var onConfirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var nft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this.level = level === 'high' ? 'high' : 'low';
      this.onConfirm = typeof onConfirm === 'function' ? onConfirm : null;
      var publisher = '';
      var raw = (nft === null || nft === void 0 ? void 0 : nft.saito) || (nft === null || nft === void 0 || (_nft$tx = nft.tx) === null || _nft$tx === void 0 || (_nft$tx = _nft$tx.returnMessage()) === null || _nft$tx === void 0 || (_nft$tx = _nft$tx.data) === null || _nft$tx === void 0 ? void 0 : _nft$tx.saito);
      if (typeof raw === 'string' && raw.indexOf('data:') === 0 && raw.indexOf('base64,') >= 0) {
        var payload = raw.indexOf('data:application/octet-stream;base64,') >= 0 ? raw : raw.substring(raw.indexOf('base64,') + 7);
        raw = this.app.crypto.base64ToString(payload);
      }
      var web = raw;
      if (typeof raw === 'string' && raw) {
        try {
          web = JSON.parse(raw);
        } catch (err) {
          web = null;
        }
      }
      if (web && _typeof(web) === 'object') {
        var _this$app;
        publisher = web.publisher || '';
        if (!publisher && web.m && (_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.crypto) !== null && _this$app !== void 0 && _this$app.base64ToString) {
          try {
            var msg = JSON.parse(this.app.crypto.base64ToString(web.m));
            publisher = msg.publisher || '';
          } catch (err) {}
        }
      }
      this.overlay.show(NFTSecurityOverlayTemplate(publisher));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var ok = document.getElementById('nft-security-ok');
      var sure = document.getElementById('nft-security-sure');
      var optout = document.getElementById('nft-security-dont-show');
      if (ok) {
        ok.onclick = function () {
          _this.overlay.close();
        };
      }
      if (sure) {
        sure.onclick = function () {
          if (optout && optout.checked) {
            if (!_this.app.options.permissions) {
              _this.app.options.permissions = {};
            }
            _this.app.options.permissions.hide_nft_security_warning = true;
            _this.app.storage.saveOptions();
          }
          _this.overlay.close();
          if (_this.onConfirm) {
            _this.onConfirm();
          }
        };
      }
    }
  }]);
}();
module.exports = NFTSecurityOverlay;